module.exports = __webpack_public_path__ + "static/media/bg-triangle.d8bfc47e.svg";